import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AccommodationsSection from '../components/AccommodationsSection';

const AccommodationsPage = () => {
  return (
    <div data-testid="accommodations-page">
      <Navbar />
      
      {/* Hero Banner */}
      <section className="bg-primary text-primary-foreground py-20 md:py-28">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold tracking-tight mb-6">
            Accommodations Navigation Support
          </h1>
          <p className="text-lg md:text-xl leading-relaxed text-primary-foreground/90 max-w-3xl mx-auto">
            Expert guidance for families navigating standardized testing accommodations with clarity, integrity, and confidence.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <AccommodationsSection />
      
      <Footer />
    </div>
  );
};

export default AccommodationsPage;
